import { Separator } from '../../../../../primitives/separator';
import { CodeEditor } from '../../../../code-editor';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { Alignment } from '../controls/alignment';
import { Spacing } from '../controls/spacing';
import { Typography } from '../controls/typography';

import { CODE_EDITOR_LANGUAGES } from '../../../../code-editor/code-editor-languages';

import type { HtmlEditorContentProps } from './types';

export type { HtmlEditorStyleUpdates } from './types';

export function HtmlEditorContent({
  alignment,
  backgroundColor,
  content,
  fontFamily,
  fontSize,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  textColor,
  theme,
  onContentChange,
  onStyleChange,
}: HtmlEditorContentProps) {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <p className="text-xs font-medium">Contenido</p>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Bloque de código HTML
          </LabelWithoutRef>
          <CodeEditor
            id="content-html"
            language={CODE_EDITOR_LANGUAGES.html}
            theme={theme === 'dark' ? 'vs-dark' : 'light'}
            value={content}
            onChange={(newContent) => onContentChange(newContent ?? '')}
          />
        </div>
      </div>

      <Separator />

      <Typography
        backgroundColor={backgroundColor}
        fontFamily={fontFamily}
        fontSize={fontSize}
        isBackgroundColorVisible
        isFontFamilyVisible
        isFontSizeVisible
        isTextColorVisible
        textColor={textColor}
        onBackgroundColorChange={(newBackgroundColor) =>
          onStyleChange({ backgroundColor: newBackgroundColor ?? null })
        }
        onFontFamilyChange={(newFontFamily) => onStyleChange({ fontFamily: newFontFamily })}
        onFontSizeChange={(newFontSize) => onStyleChange({ fontSize: newFontSize })}
        onTextColorChange={(newTextColor) => onStyleChange({ color: newTextColor ?? null })}
      />

      <Separator />

      <Alignment
        isHorizontalAlignmentVisible
        horizontalAlignment={alignment}
        onHorizontalAlignmentChange={(newAlignment) => onStyleChange({ textAlign: newAlignment })}
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
